// @flow

import styled from 'styled-components';

export default styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:focus {
    outline: 0;
  }
`;
